window.unSaveChangeDialog = function (discardChanges, continueEdit, url, msg) {
    discardChanges = !discardChanges ? window.onDiscardChanges : discardChanges;
    continueEdit = !continueEdit ? window.onContinueEdit : continueEdit;
    msg = msg ? msg : "Do you really want to discard your changes?";

    let confirmBox = $("#confirmPopup");
    confirmBox.find(".message").text(msg);
    confirmBox.find(".yes,.no").unbind().click(function () {
        document.getElementById('confirmPopup')?.hide();
    });
    confirmBox.find(".yes").click(function () {
        discardChanges(url);
    });

    confirmBox.find(".no").click(continueEdit);
    document.getElementById('confirmPopup')?.show();
};

window.setFormSubmitting = function () {
    window.isByPassDetectDataChanged = true;
}

window.onbeforeunload = function (e) {
    if (window.eventChangedListener
        && typeof window.eventChangedListener === "function"
        && eventChangedListener() && !window.isByPassDetectDataChanged) {
        return "Do you really want to discard your changes?";
    }

    window.isByPassDetectDataChanged = false;
};

window.onDiscardChanges = function (url) {
    window.isByPassDetectDataChanged = true;
    window.location.href = url;
}

window.onContinueEdit = function () {
    window.isByPassDetectDataChanged = false;
}

onSetButtonStyle = function (buttonElement, isActive = true, customClass = null) {
    if (isActive) {
        buttonElement.attr("variant", customClass ? customClass : "success");
        buttonElement.removeAttr("disabled");
    } else {
        buttonElement?.attr("disabled", true);
        buttonElement?.attr("variant", customClass ? customClass : "neutral");
    }
}

onSubmitForm = function (event, form) {
    const isValid = $(form).valid();
    if (!isValid) {
        event.preventDefault();
        return;
    }

    preventMultipleSubmit(event, form);
}

preventMultipleSubmit = function (event, form, buttonElement) {
    const submitButton = buttonElement
        ? form.querySelector(buttonElement)
        : form.querySelector("viedoc-button[type='submit']");

    if (submitButton) {
        if (!submitButton.hasAttribute('disabled')) {
            submitButton.disabled = true;
        } else {
            event.preventDefault();
            return;
        }
    }
}


$("#sidebarMenu .menu-item, #viedocLogo").on('click', function (e) {
    e.preventDefault();
    const url = $(e.currentTarget).attr('url');
    const msg = $(e.currentTarget).attr('msg');
    if (url) {
        // show config dialog if any data changed on page
        if (window.eventChangedListener && typeof window.eventChangedListener === "function" && eventChangedListener()) {
            unSaveChangeDialog(onDiscardChanges, onContinueEdit, url, msg);
        }
        // case don't change anything on page
        else {
            window.isByPassDetectDataChanged = false;
            window.location.href = url;
        }
    }
});
